export default __webpack_public_path__ + "static/pave-8220867eb6c1979d2ace1849a4e95132.svg";